module.exports = __webpack_public_path__ + "static/img/medal.031a1bb4.svg";